import { View } from './view';

export const TabsList = View;
